import { Reveal } from "@/components/okaia/Reveal";
import { Check } from "lucide-react";

const ITEMS = [
  "Un état des lieux synthétique de votre projet ou de votre activité.",
  "Une priorité clairement identifiée.",
  "Cinq actions adaptées à vos moyens : trois prioritaires et deux à engager ensuite.",
  "Une synthèse écrite pour avancer après l'entretien.",
];

export const Benefits = () => (
  <section id="benefices" data-testid="section-benefices" className="bg-[#F0EBE1] py-16 md:py-24">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="grid items-center gap-12 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Reveal>
            <p className="okaia-overline mb-6 text-[#B39265]">Chapitre 02 — Le résultat</p>
            <h2 className="font-serif-display text-4xl leading-[1.1] tracking-tight text-[#0B2215] md:text-5xl">
              Ce que vous obtenez
            </h2>
            <p className="mt-5 max-w-xl text-base font-light leading-relaxed text-[#4A5A52]">
              Un premier diagnostic ciblé de 30 minutes pour faire le point sur un blocage
              précis — sans prétendre résoudre l'ensemble des difficultés d'une entreprise.
            </p>
          </Reveal>
          <div className="mt-8">
            {ITEMS.map((item, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div data-testid={`benefit-${i + 1}`} className="flex items-start gap-5 border-t border-[#0B2215]/15 py-5 last:border-b">
                  <span className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center border border-[#C8A97E] text-[#B39265]">
                    <Check className="h-3.5 w-3.5" />
                  </span>
                  <p className="font-serif-display text-lg leading-snug text-[#0B2215] md:text-xl">{item}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 lg:col-span-5 lg:col-start-8">
          <Reveal delay={0.1}>
            <figure>
              <img src="/illus-clarification.jpg" alt="Illustration : réflexion et clarification de la situation" className="w-full border border-[#C8A97E]/30" loading="lazy" />
              <figcaption className="mt-2 text-xs font-light italic text-[#4A5A52]">Clarifier</figcaption>
            </figure>
          </Reveal>
          <Reveal delay={0.2}>
            <figure>
              <img src="/illus-plan.jpg" alt="Illustration : plan d'action synthétique" className="w-full border border-[#C8A97E]/30" loading="lazy" />
              <figcaption className="mt-2 text-xs font-light italic text-[#4A5A52]">Agir</figcaption>
            </figure>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
